import { Injectable } from '@angular/core';

import { AppSettings } from './../app.settings';
import { UserService } from './user.service';
import { CommonRequestService } from './common-request.service';
import { ToastrService } from 'ngx-toastr';


export interface Subscription {
	subId: number; // subscription id
	cusId: number; // subscription's customer id
	appName: string;
	// subCgsIdLevel: number;
	// subCgsAuthTypeId: number;
	subLocked: boolean;
	subLevel: string; // eg. 'TRIAL'
	subAuthType: string; // eg. 'LB MANAGED'
	startDate: any;
	term: any; // eg. 365
	// subTranxCreate: string;
	// subTranxDelete: string;
	isExpired: boolean;
	expireDate: string;
}
export interface UserSubscription {
	userId: number;
	userSubId: number;
	role: string; // eg. 'OPERATOR',
	userEmail: string;
	cusNameShort: string;
	cusEmail: string;
	userSsoName: string; // ???
	appName: string;
	subId: number;
	subLevel: string; // eg. 'STARTER',
	subAuthType: string; // eg. 'LB MANAGED',
}

export interface UpdateCustomerProps {
	customerShortName?: string,
	customerLongName?: string,
	customerType?: string,
	fcNamePrefix?: string,
	auth?: string,
	discripAgId?: string,
	givBoundaryName?: string,
	givBoundaryCat?: string,
	customerCentroid?: string,
	customerCounties?: string[],
	customerState?: string;
	customerNguidPattern?: number; // 1 or 2
}

@Injectable()
export class AdminService {

	constructor(
		private toastr: ToastrService,
		private userService: UserService,
		private requestService: CommonRequestService
	) { }
	// Get the subscription of current agency and app
	getSubscription(successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'admin/subscription';
		const params = {
			customerId: JSON.stringify(this.userService.getUserInfo().customerId),
			application: AppSettings.appName
		};
		this.requestService.requestGet(url, {
			params: params
		},
			(rsp) => {
				const subscriptions = this.transformSubscriptions(rsp.data);
				if (successCallback) {
					successCallback(subscriptions);
				}
			}, errorCallback);
	}
	transformSubscriptions(data: any[]): Subscription[] {
		const subscriptions: Subscription[] = [];
		data.forEach((item) => {
			subscriptions.push({
				subId: item.sub_id,
				cusId: item.sub_cus_id,
				appName: item.sub_mod_cd,
				// subCgsIdLevel: item.sub_cgs_id_sub_level,
				// subCgsAuthTypeId: item.sub_cgs_id_auth_type,
				subLocked: item.sub_locked,
				startDate: item.sub_start,
				term: item.sub_term,
				// subTranxCreate: item.sub_tranx_create,
				// subTranxDelete: item.sub_tranx_delete,
				subLevel: item.sub_cgs_sub_level,
				subAuthType: item.sub_cgs_auth_type,
				isExpired: item.expired,
				expireDate: item.expire_date
			});
		});
		return subscriptions;
	}
	// Add Subscription to current customer
	// TODO: Change Hard Code
	addSubscription(customerId, appName, subLevel, adminId, startDate?, term?) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/subscription';
			const body: any = {
				customerId: customerId,
				application: appName,
				level: subLevel, // level of sub, basic/professional.... // 1019, // trial
				authType: 'LB MANAGED', // 1018, // LB Managed
				adminId: adminId
			};
			if (startDate) {
				body.startDate = startDate;
			}
			if (term) {
				body.term = term; // days of subscribtion
			}
			return this.requestService.requestPost(url, body, rsp => resolve(rsp), err => reject(err), true);
	
		});
	}
	// Add Subscription to a user under the current customer
	addUserSubscription(userId, subscriptionId, roleId) {
		return new Promise((resolve, reject) => {
			const body = {
				userId: userId,
				subscriptionId: subscriptionId,
				roleId: roleId,
				adminId: this.userService.getUserInfo().userId // user has to be admin to call this service
			};
			this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/userSubscription', body, rsp => resolve(rsp), err => reject(err), true);	
		});
	}

	getUserSubscription(email?: string, appName?) {
		return new Promise<UserSubscription[]>((resolve, reject) => {
			const params: any = {
				application: appName || AppSettings.appName,
				customerId: this.userService.getUserInfo().customerId.toString()
			}
			if (email) {
				params.email = email;
			}
			this.requestService.requestGet(AppSettings.serviceRootUrl + 'admin/userSubscription', {
				params: params
			},
				rsp => {
					const userSubs: UserSubscription[] = [];
					if (rsp.data) {
						rsp.data.forEach((item) => {
							userSubs.push({
								userId: item.usr_id,
								userSubId: item.usb_id,
								role: item.rol_cgs_role, // eg. 'OPERATOR',
								userEmail: item.usr_email,
								cusNameShort: item.cus_name_short,
								cusEmail: item.cus_email,
								userSsoName: item.usr_sso_name,
								appName: item.sub_mod_cd,
								subId: item.sub_id,
								subLevel: item.sub_cgs_sub_level, // eg. 'STARTER',
								subAuthType: item.sub_cgs_auth_type // eg. 'LB MANAGED',
							});
						});
					}
					resolve(userSubs);
				},
				err => reject(err),
				true);
		});
	}
	deleteUserSubscription(userId, subscriptionId, roleId, successCallback?, errorCallback?) {
		const body = {
			userId: userId,
			subscriptionId: subscriptionId,
			roleId: roleId, // ??
			adminId: this.userService.getUserInfo().userId
		};
		const options = {
			body: body
		};
		return this.requestService.requestDelete(AppSettings.serviceRootUrl + 'admin/userSubscription', options, successCallback, errorCallback);
	}
	updateUserSubscription(usbId, roleId): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/userSubscription';
			const body = {
				userSubscriptionId: usbId,
				roleId: roleId
			};
			this.requestService.requestPut(url, body, () => {
				resolve();
			}, (err) => {
				reject(err);
			});
		});
	}

	addUser(email) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/user';
			const body = {
				email: email,
				customerId: this.userService.getUserInfo().customerId,
				adminId: this.userService.getUserInfo().userId
			};
			this.requestService.requestPost(url, body, (rsp) => {
				resolve(rsp);
			}, err => reject(err));
		})
	}
	deleteUser(email) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/user';
			const body = {
				email: email,
				adminId: this.userService.getUserInfo().userId,
				customerId: this.userService.getUserInfo().customerId
			};
			const options = {
				body: body
			};
			return this.requestService.requestDelete(url, options, (rsp) => resolve(rsp), err => reject(err));
		});
	}
	// Add or remove the site-admin property for user
	updateUserAdmin(isAdmin: boolean, userEmail: string) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/user';
			const bodyUpdate = {
				email: userEmail,
				isAdmin: isAdmin
			};
			this.requestService.requestPut(url, bodyUpdate, (rsp) => {
				resolve(rsp);
			}, (err) => {
				reject(err);
			}, true);
		});
	}
	checkUserExist(email: string) {
		return new Promise((resolve, reject) => {
			resolve(1374);
			// const url = AppSettings.serviceRootUrl + ''; // TODO
			// const params = new URLSearchParams();
			// const options = new RequestOptions();
			// params.set('email', email);
			// options.params = params;
			// this.requestService.requestGet(url, options, rsp => resolve(rsp), err => reject(err));
		});
	}

	deleteCustomer(customerId: number) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/customer';
			const body = {
				customerId: customerId,
				adminId: this.userService.getUserInfo().userId
			};
			const options = {
				body: body
			};
			this.requestService.requestDelete(url, options, rsp => resolve(), err => reject(err));
		});
	}
	updateCustomer(props: UpdateCustomerProps, cusId?: number) {
		return new Promise((resolve, reject) => {
			const body: any = {
				// customerShortName: shortName,
				customerId: cusId ? cusId : this.userService.getUserInfo().customerId
			};
			const attrs = [
				'customerShortName',
				'customerLongName',
				'customerId',
				'parentId',
				'customerType',
				'fcNamePrefix',
				'auth',
				'discripAgId',
				'givBoundaryName',
				'givBoundaryCat',
				'customerCentroid',
				'customerCounties',
				'customerState',
				'customerNguidPattern'
			];
			Object.keys(props).forEach(k => {
				if (attrs.indexOf(k) > -1 && props[k]) {
					if (k === 'customerCounties') {
						if (props[k].length) {
							body[k] = JSON.stringify(props[k])
						}
					} else {
						body[k] = props[k];
					}
				}
			})
			const url = 'admin/customer';
			this.requestService.requestPut(AppSettings.serviceRootUrl + url, body, rsp => resolve(rsp.data), err => reject(err));
		});
	}

	checkLongTransactions() {
		return new Promise<boolean>((resolve, reject) => {
			// resolve(false)
			const params: any = {
				customerId: this.userService.getUserInfo().customerId.toString()
			}
			this.requestService.requestGet(AppSettings.serviceRootUrl + 'admin/longTransactions', {
				params: params
			},
				rsp => {
					let exist = false;
					if (rsp.data && rsp.data.length) {
					// if (rsp.misc && rsp.misc.message && rsp.data && rsp.data[0]) {
						exist = true;
						const userEmail = rsp.data[0].usr_email;
						const desc = rsp.data[0].txs_desc;
						const date = new Date(rsp.data[0].txs_start);
						let message = `Long transaction ${desc} by ${userEmail} started on ${date.toString()} is still running.  Please wait until it is completed.`
						this.toastr.info(message);
					}
					resolve(exist);
				},
				err => reject(err));
		});
	}

}
